import {
  InfrastructureGroupConfigurationDto,
  InfrastructureFirmwareDto,
  InfrastructureGroupDto,
  InfrastructureGroupSearchRequest,
  InfrastructureHardwareDto,
  InfrastructureHardwareRequest,
  InfrastructureHardwareSearchRequest,
  UpdateInfrastructureGroupConfigurationDto,
  CreateDeployJobsRequestDto,
  InfrastructureGroupConfigurationSearchRequest,
  DeployJobSearchRequest,
  SearchDeployJobsResponseDto,
  InfrastructureGroupConfigurationHistorySearchRequest,
  GroupsWithMatchingType,
  InfrastructureHardwaresInGroupDto,
  UpdateInfrastructureGroupDto
} from '~/models/api/InfrastructureApi.model'
import axiosClient from './axiosClient'
import {
  INFRASTRUCTURE_GET_FIRMWARE_API,
  INFRASTRUCTURE_GET_GROUP_API,
  INFRASTRUCTURE_GET_HARDWARE_API,
  INFRASTRUCTURE_POST_GROUP_API,
  INFRASTRUCTURE_POST_HARDWARE_API,
  INFRASTRUCTURE_POST_FIRMWARE_API,
  INFRASTRUCTURE_PUT_GROUP_API,
  INFRASTRUCTURE_DELETE_GROUP_API,
  INFRASTRUCTURE_PUT_GROUP_CONFIGURATION_API,
  INFRASTRUCTURE_PUT_HARDWARE_API,
  INFRASTRUCTURE_SEARCH_GROUP_API,
  INFRASTRUCTURE_SEARCH_HARDWARE_API,
  INFRASTRUCTURE_GET_CONFIGURATION_API,
  INFRASTRUCTURE_PUT_CONFIGURATION_APPROVE_API,
  INFRASTRUCTURE_POST_CONFIGURATION_DEPLOY_API,
  INFRASTRUCTURE_DELETE_HARDWARE_API,
  INFRASTRUCTURE_BATCH_DELETE_HARDWARE_API,
  INFRASTRUCTURE_GET_DEPLOYJOBS_API,
  INFRASTRUCTURE_GET_GROUPS_WITH_MATCHING_TYPE_API,
  INFRASTRUCTURE_MOVE_TO_GROUP_API,
  INFRASTRUCTURE_GET_CONFIGURATIONS_API,
  INFRASTRUCTURE_POST_BULKFIRMWARE_OBSOLETE_API,
  INFRASTRUCTURE_POST_BULKFIRMWARE_RESTORE_API,
  INFRASTRUCTURE_DONWLOAD_DEPLOYJOBS_PROGRAMMINGLOG_API
} from '~/constants/APIs/infrastructure'
import { PageResultDto } from '~/models/api/Api.model'
import { IBaseStationFirmwareSearchRequest } from '~/pages/BaseStation/BaseStationFirmware/Firmware.model'

export const infrastructureApis = {
  searchGroups: async (params: InfrastructureGroupSearchRequest) =>
    axiosClient.get<PageResultDto<InfrastructureGroupDto>>(INFRASTRUCTURE_SEARCH_GROUP_API, {
      params
    }) as unknown as Promise<PageResultDto<InfrastructureGroupDto>>,
  getGroup: async (groupId: number) =>
    axiosClient.get<InfrastructureGroupDto>(INFRASTRUCTURE_GET_GROUP_API + groupId.toString()) as unknown as Promise<InfrastructureGroupDto>,
  createGroup: async (infrastructureGroupDto: UpdateInfrastructureGroupDto) =>
    axiosClient.post(INFRASTRUCTURE_POST_GROUP_API, infrastructureGroupDto) as unknown as Promise<InfrastructureGroupDto>,
  updateGroup: async (infrastructureGroupDto: UpdateInfrastructureGroupDto) =>
    axiosClient.put(INFRASTRUCTURE_PUT_GROUP_API + infrastructureGroupDto.id, infrastructureGroupDto) as unknown as Promise<InfrastructureGroupDto>,
  getGroupsWithMatchingType: async (groupId: number | null) =>
    axiosClient.get(INFRASTRUCTURE_GET_GROUPS_WITH_MATCHING_TYPE_API, { params: { groupId } }) as unknown as Promise<GroupsWithMatchingType[]>,
  deleteGroup: async (groupId: number) => axiosClient.delete(INFRASTRUCTURE_DELETE_GROUP_API + groupId) as unknown as Promise<any>,

  searchHardware: async (params: InfrastructureHardwareSearchRequest) =>
    axiosClient.get<PageResultDto<InfrastructureHardwaresInGroupDto>>(INFRASTRUCTURE_SEARCH_HARDWARE_API, {
      params
    }) as unknown as Promise<PageResultDto<InfrastructureHardwaresInGroupDto>>,
  getHardware: async (hardwareId: number, params: InfrastructureHardwareRequest) =>
    axiosClient.get<InfrastructureHardwareDto>(INFRASTRUCTURE_GET_HARDWARE_API + hardwareId, {
      params
    }) as unknown as Promise<InfrastructureHardwareDto>,
  createHardware: async (infrastructureHardwareDto: InfrastructureHardwareDto) =>
    axiosClient.post(INFRASTRUCTURE_POST_HARDWARE_API, infrastructureHardwareDto) as unknown as Promise<InfrastructureHardwareDto>,
  updateHardware: async (infrastructureHardwareDto: InfrastructureHardwareDto) =>
    axiosClient.put(
      INFRASTRUCTURE_PUT_HARDWARE_API + infrastructureHardwareDto.id,
      infrastructureHardwareDto
    ) as unknown as Promise<InfrastructureHardwareDto>,

  deleteHardware: async (hardwareId: number) => axiosClient.delete(INFRASTRUCTURE_DELETE_HARDWARE_API + hardwareId) as unknown as Promise<any>,
  deleteHarwareList: async (data: { ids: number[] }) => axiosClient.post(INFRASTRUCTURE_BATCH_DELETE_HARDWARE_API, data) as unknown as Promise<any>,
  moveToGroup: (data: {
    targetGroupId: number | null
    hardwareIds: string[]
  }) => axiosClient.post(INFRASTRUCTURE_MOVE_TO_GROUP_API, data),

  searchFirmware: async (params?: IBaseStationFirmwareSearchRequest) =>
    axiosClient.get<PageResultDto<InfrastructureFirmwareDto>>(INFRASTRUCTURE_GET_FIRMWARE_API, { params }) as unknown as Promise<
      PageResultDto<InfrastructureFirmwareDto>
    >,
  getFirmware: async (firmwareId: number, includeDeleted: boolean) =>
    axiosClient.get<InfrastructureFirmwareDto>(INFRASTRUCTURE_GET_FIRMWARE_API + `/${firmwareId}`, {
      params: { includeDeleted: includeDeleted }
    }) as unknown as Promise<InfrastructureFirmwareDto>,
  deleteFirmware: async (firmwareId: number) =>
    axiosClient.delete<InfrastructureFirmwareDto>(
      INFRASTRUCTURE_GET_FIRMWARE_API + `/${firmwareId}`
    ) as unknown as Promise<InfrastructureFirmwareDto>,
  bulkDeleteFirmware: async (firmwareIds: number[]) =>
    axiosClient.post<InfrastructureFirmwareDto>(
      INFRASTRUCTURE_POST_BULKFIRMWARE_OBSOLETE_API, firmwareIds
    ) as unknown as Promise<InfrastructureFirmwareDto>,
  unDeleteFirmware: async (firmwareId: number) =>
    axiosClient.post<InfrastructureFirmwareDto>(INFRASTRUCTURE_GET_FIRMWARE_API + `/${firmwareId}`) as unknown as Promise<InfrastructureFirmwareDto>,
  bulkUnDeleteFirmware: async (firmwareIds: number[]) =>
    axiosClient.post<InfrastructureFirmwareDto>(INFRASTRUCTURE_POST_BULKFIRMWARE_RESTORE_API, firmwareIds) as unknown as Promise<InfrastructureFirmwareDto>,


  uploadFirmware: async () => axiosClient.put(INFRASTRUCTURE_POST_FIRMWARE_API) as unknown as Promise<InfrastructureFirmwareDto[]>,
  updateGroupConfiguration: async (configurationId: number, groupConfiguration: UpdateInfrastructureGroupConfigurationDto) =>
    axiosClient.put(
      INFRASTRUCTURE_PUT_GROUP_CONFIGURATION_API + configurationId,
      groupConfiguration
    ) as unknown as Promise<InfrastructureGroupConfigurationDto>,
  getConfiguration: async (configurationId: number) =>
    axiosClient.get<InfrastructureGroupConfigurationDto>(
      INFRASTRUCTURE_GET_CONFIGURATION_API + configurationId
    ) as unknown as Promise<InfrastructureGroupConfigurationDto>,
  searchConfiguration: async (params: InfrastructureGroupConfigurationSearchRequest) =>
    axiosClient.get<InfrastructureGroupConfigurationDto>(INFRASTRUCTURE_GET_CONFIGURATION_API, {
      params
    }) as unknown as Promise<PageResultDto<InfrastructureGroupConfigurationDto>>,
  getConfigurations: async (params: InfrastructureGroupConfigurationHistorySearchRequest) =>
    axiosClient.get<InfrastructureGroupConfigurationDto>(INFRASTRUCTURE_GET_CONFIGURATIONS_API + params.groupId) as unknown as Promise<
      Array<InfrastructureGroupConfigurationDto>
    >,
  approveConfiguration: async (configurationId: number) =>
    axiosClient.post(INFRASTRUCTURE_PUT_CONFIGURATION_APPROVE_API + `?configId=${configurationId}`) as unknown as Promise<any>,
  deployConfiguration: async (deploymentRequest: CreateDeployJobsRequestDto) =>
    axiosClient.post(INFRASTRUCTURE_POST_CONFIGURATION_DEPLOY_API, deploymentRequest) as unknown as Promise<any>,
  searchDeployJobs: async (params: DeployJobSearchRequest) =>
    axiosClient.get<PageResultDto<SearchDeployJobsResponseDto>>(INFRASTRUCTURE_GET_DEPLOYJOBS_API, { params }) as unknown as Promise<
      PageResultDto<SearchDeployJobsResponseDto>
    >,
  cancelDeployJob: async (id: number) => 
    axiosClient.delete(`${INFRASTRUCTURE_GET_DEPLOYJOBS_API}/${id}`) as unknown as Promise<any>,
  downloadDeployJobsProgrammingLog: async (id: number) => 
    axiosClient.get(INFRASTRUCTURE_DONWLOAD_DEPLOYJOBS_PROGRAMMINGLOG_API + '/' + id + '/log', {responseType: 'blob'})
}
